import { render, staticRenderFns } from "./AIAgentLoader.vue?vue&type=template&id=3e54f8f2&scoped=true"
import script from "./AIAgentLoader.vue?vue&type=script&lang=ts"
export * from "./AIAgentLoader.vue?vue&type=script&lang=ts"
import style0 from "./AIAgentLoader.vue?vue&type=style&index=0&id=3e54f8f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54f8f2",
  null
  
)

export default component.exports